var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0a579b",
    width: 34.462,
    height: 28,
    viewBox: "0 0 34.462 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(-69.769 -601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "briefcase",
    d: "M14,1a3.231,3.231,0,0,0-3.231,3.231V5.308H3.231A3.231,3.231,0,0,0,0,8.539V25.769A3.231,3.231,0,0,0,3.231,29h28a3.231,3.231,0,0,0,3.231-3.231V8.539a3.231,3.231,0,0,0-3.231-3.231H23.693V4.231A3.231,3.231,0,0,0,20.462,1Zm0,2.154h6.462a1.077,1.077,0,0,1,1.077,1.077V5.308H12.923V4.231A1.077,1.077,0,0,1,14,3.154Zm4.062,14.892,14.246-3.8V25.769a1.077,1.077,0,0,1-1.077,1.077h-28a1.077,1.077,0,0,1-1.077-1.077V14.246l14.246,3.8a3.231,3.231,0,0,0,1.663,0ZM3.231,7.462h28a1.077,1.077,0,0,1,1.077,1.077v3.481l-14.8,3.946a1.077,1.077,0,0,1-.556,0l-14.8-3.946V8.539A1.077,1.077,0,0,1,3.231,7.462Z",
    transform: "translate(69.769 600)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.8a06d879203080dcbffae696e80384a7.svg";
export { ForwardRef as ReactComponent };